export const goTo = (navigate: any, url: any) => {
	navigate.push(url)
}
